import { GET_CATEGORIES_SLIDER } from "./actionTypes";

const initialState = {
    categories_slides: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CATEGORIES_SLIDER:
            return { ...state, categories_slides: action.payload };
        default:
            return state;
    }
}
